
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';

import { Order } from '@/models/order';

import orderServices from '@/services/order-service';
import authService from '@/services/auth-services';

import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import formatNumber from '@/shared/filters/format-number';

@Component({
    components: {
        ConfirmModal,
        Loading
    }
})
export default class OrderDetailFooter extends Vue {
    private eventEmit = {
        eventCancelOrder: 'eventCancelOrder',
        eventDepositOrder: 'eventDepositOrder',
        eventReOrder: 'eventReOrder'
    };

    private actions = {
        cancel: 'cancel',
        deposit: 'deposit',
        complain: 'complain',
        reorder: 'reorder'
    };
    private actionSelected: any = this.actions.cancel;
    
    @Prop({default: null})
    private order!: Order;

    @Prop({default: {}})
    private customerInfo: any;

    private isConfirm = false;
    private showNextConfirm = true;
    private isLoading = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';
    
    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async onActionStatus(action: any) {
        this.actionSelected = action;
        switch(this.actionSelected) {
            case this.actions.cancel: {
                this.modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
            case this.actions.complain: {
                this.$router.push({ name: 'order-complain', params: { orderId: this.order.id.toString() } });
                break;
            }
            case this.actions.deposit: {
                this.modalContent = `<div style="color: #111">Số tiền bạn cần đặt cọc là <label class="fb text-danger">${ formatNumber(this.order.needDeposit, '0,0') } vnđ.</label>
                                    <div>Bạn có muốn đặt cọc không?</div></div>`;
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
            case this.actions.reorder: {
                this.modalContent = 'Bạn có thực sự muốn đặt lại đơn hàng này không?';
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
        }
    }

    private async onCancelOrder() {
        this.isLoading = true;
        const dataRequest =  {
            Status: 1
        };
        const result = await orderServices.updateOrder(this.order.id, dataRequest);
        
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Hủy đơn hàng thành công!',
            });
            this.$emit(this.eventEmit.eventCancelOrder, { status: 1 });
            this.isLoading = false;
        }
    }

    private async onDepositOrder() {
        if (this.customerInfo.Wallet >= this.order.needDeposit) {
            this.isLoading = true;

            const dataRequest = {
                Status: 2,
                Deposit: this.order.needDeposit
            };
            const result = await orderServices.updateOrder(this.order.id, dataRequest);
            if (result && result.status === 200 && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Đặt cọc thành công!',
                });
                this.$emit(this.eventEmit.eventDepositOrder, { status: 2 });
                this.isLoading = false;

                this.getCustomersInfo();
            }
        } else {
            this.modalContent = '<div style="color: #111;">Số tiền trong ví của bạn không đủ để đặt cọc.</div><div class="text-danger">Hãy nạp tiền để tiếp tục đặt cọc!</div>';
            this.isConfirm = true;
            this.showNextConfirm = false;
        }
        
    }

    private async onReOrder() {
        this.isLoading = true;

        const dataRequest = {
            Status: 0,
            Deposit: 0
        };
        const result = await orderServices.updateOrder(this.order.id, dataRequest);
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Đặt lại đơn hàng thành công!',
            });
            this.$emit(this.eventEmit.eventReOrder, { status: 0 });
        }
        this.isLoading = false;
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK' && this.actionSelected === this.actions.cancel) {
            this.onCancelOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === this.actions.deposit) {
            this.onDepositOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === this.actions.reorder) {
            this.onReOrder();
        }
    }

    private async created() {
        await this.getCustomersInfo();
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
            }
        }
    }
}
